import { Modal, Typography, Button } from 'antd';
import { PhoneIcon } from 'assets';
import React from 'react';

interface MissedCallModalProps {
    open: boolean;
    onClose: () => void;
    customerNumber?: string;
    callSource?: string;
    callTime?: string;
}

const MissedCallModal: React.FC<MissedCallModalProps> = ({
    open,
    onClose,
    customerNumber,
    callSource,
    callTime
}) => {
    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            centered
            width={400}
            closable={false}
            className="missed-call-modal"
        >
            <div className="flex flex-col items-center p-6">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                    <PhoneIcon className="w-8 h-8 text-red-500" />
                </div>

                <Typography.Title level={4} className="text-center mb-2 text-red-600">
                    Cuộc gọi nhỡ
                </Typography.Title>

                <Typography.Text className="text-center text-gray-600 mb-4">
                    Bạn đã bỏ lỡ một cuộc gọi
                </Typography.Text>

                {customerNumber && (
                    <div className="w-full bg-gray-50 rounded-lg p-3 mb-4">
                        <div className="flex justify-between items-center mb-2">
                            <Typography.Text className="text-sm text-gray-500">
                                Số điện thoại:
                            </Typography.Text>
                            <Typography.Text className="font-semibold">
                                {customerNumber}
                            </Typography.Text>
                        </div>

                        {callSource && (
                            <div className="flex justify-between items-center mb-2">
                                <Typography.Text className="text-sm text-gray-500">
                                    Nguồn cuộc gọi:
                                </Typography.Text>
                                <Typography.Text className="font-semibold">
                                    {callSource}
                                </Typography.Text>
                            </div>
                        )}

                        {callTime && (
                            <div className="flex justify-between items-center">
                                <Typography.Text className="text-sm text-gray-500">
                                    Thời gian:
                                </Typography.Text>
                                <Typography.Text className="font-semibold">
                                    {callTime}
                                </Typography.Text>
                            </div>
                        )}
                    </div>
                )}

                <Button
                    type="primary"
                    onClick={onClose}
                    className="w-full bg-blue-500 border-blue-500 hover:bg-blue-600"
                >
                    Đã hiểu
                </Button>
            </div>
        </Modal>
    );
};

export default MissedCallModal;
